export const checked = val => !!val

const PHONE_REGEX = /^(?:\+34|34|0034)?[679]{1}[0-9]{8}$/
export const validPhone = phone => PHONE_REGEX.test(phone)
